// Maps French backend error details to translation keys.
const MAP = [
  [/^Identifiants incorrects/, "err.badCredentials"],
  [/^Catégorie et compatibilité obligatoires/, "plat.required"],
  [/^Choisissez d'abord l'application et la REF/, "biz.errScope"],
  [/^REF invalide/, "biz.errRef"],
  [/^Le lien iPhone est obligatoire/, "plat.linkRequired"],
  [/^Lien iPhone invalide/, "plat.linkInvalid"],
  [/^Accès refusé/, "err.denied"],
  [/^Trop de tentatives de paiement/, "pay.rate"],
  [/^Forte affluence/, "pay.busy"],
  [/^Paiements désactivés dans l'aperçu/, "pay.preview"],
  [/^Trop de tentatives/, "err.tooMany"],
  [/^Seuls les fichiers APK/, "err.apkOnly"],
  [/^La version (.+) existe déjà/, "err.versionExists"],
  [/^Cette version \((.+)\) est déjà en ligne/, "err.versionOnline"],
  [/^Aucune icône trouvée dans l'APK/, "err.noApkIcon"],
  [/^Cet APK appartient à une autre application \(paquet (.+)\)/, "err.otherPackage"],
  [/^Stockage momentanément indisponible/, "err.storageDown"],
  [/^Accès Google Drive refusé/, "err.driveDenied"],
  [/^Note de 1 à 5 étoiles obligatoire/, "reviews.invalid"],
  [/^Lien non autorisé/, "err.linkNotAllowed"],
  [/^Valeurs invalides/, "err.invalidValues"],
  [/^Paiements temporairement indisponibles/, "billing.unavailable"],
  [/^Purge déjà en cours/, "err.purgeRunning"],
  [/^Aucun appareil abonné/, "err.noPushDevice"],
  [/^Conversation fermée/, "err.convClosed"],
  [/^Trop de messages/, "err.tooManyMsg"],
  [/^Forfait sur mesure introuvable/, "err.customMissing"],
  [/^Ce lien ne mène pas à un fichier APK/, "err.linkNotApk"],
  [/^Lien Drive privé/, "err.drivePrivate"],
  [/^Ce fichier n'est pas un APK valide/, "err.invalidApk"],
  [/^Supprimez d'abord (\d+) applications pour passer au forfait (\w+) \((\d+) max\)/, "err.downgrade"],
  [/^Paiement du supplément refusé/, "err.upgradePay"],
  [/^Le développeur n'a pas déclaré sa vérification/, "err.notDeclared"],
  [/^Pseudo obligatoire/, "err.reviewPseudo"],
  [/^Téléchargez l'application pour donner votre avis/, "reviews.downloadFirst"],
  [/^Vous avez déjà donné votre avis/, "err.reviewAlready"],
  [/^Trop d'avis envoyés/, "err.reviewRate"],
  [/^Avis introuvable/, "err.reviewNotFound"],
  [/^Fichier Google Drive introuvable/, "err.driveNotFound"],
  [/^Google Drive indisponible|^Copie Google Drive incomplète/, "err.driveDown"],
  [/^Connexion Google Drive non configurée/, "drive.soon"],
  [/^Google Drive n'est pas connecté/, "err.driveNotConnected"],
  [/^Partage refusé par Google Drive/, "err.driveShareDenied"],
  [/^Format d'image/, "err.imageFormat"],
  [/^Image trop volumineuse/, "err.imageTooBig"],
  [/^Le nom est obligatoire/, "err.nameRequired"],
  [/^Téléversement incomplet/, "err.incomplete"],
  [/^Téléversement introuvable/, "err.uploadNotFound"],
  [/^Application introuvable/, "err.appNotFound"],
  [/^Fichier trop volumineux/, "err.fileTooBig"],
  [/^Le texte est vide/, "err.emptyText"],
  [/^Publiez d'abord/, "err.publishFirst"],
  [/^Cet email est déjà utilisé/, "err.emailTaken"],
  [/^Cet email est (réservé|celui de l'administrateur)/, "err.adminEmail"],
  [/^Email invalide/, "err.emailInvalid"],
  [/^Abonnement requis pour publier/, "err.subRequired"],
  [/^Limite de (\d+) applications atteinte/, "err.appLimit"],
  [/^Abonnement déjà actif/, "err.alreadyActive"],
  [/^Compte suspendu par l'administrateur/, "billing.suspendedAdmin"],
  [/^Lien invalide ou expiré/, "err.resetInvalid"],
  [/^Aucun abonnement en cours|^Aucun désabonnement à annuler/, "err.noSub"],
  [/^Confirmation incorrecte/, "unsub.wrong"],
  [/^Confirmation de désabonnement requise/, "unsub.required"],
  [/^Paiement indisponible|^Stripe indisponible|^Impossible d'annuler/, "err.payment"],
  [/^Cet email est déjà dans la liste VIP/, "err.vipDuplicate"],
  [/^Forfait VIP/, "billing.vip"],
  [/^Le maximum doit être ≥ au minimum/, "err.maxMin"],
  [/^Nombre d'applications requis/, "err.appsRequired"],
  [/^Message vide/, "err.emptyText"],
  [/^Ticket expiré/, "err.ticketExpired"],
  [/^Serveur occupé|^Trop de demandes de téléchargement/, "err.serverBusy"],
  [/^IA indisponible|^IA de rédaction désactivée/, "ai.error"],
];

export function translateError(err, t, fallbackKey = "err.generic") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") {
    for (const [re, key] of MAP) {
      const m = detail.match(re);
      if (m) return t(key, { v: m[1], v2: m[2], v3: m[3] });
    }
  }
  return t(fallbackKey);
}
